/* ════════════════════════════════════════════════════════
   PureEthical — pe-gallery.js v2
   Product gallery: image grid click → lightbox
   Works with gs-img-item (Gymshark 2-col grid layout)
   ════════════════════════════════════════════════════════ */

(function() {
'use strict';

var lb     = null;
var lbImg  = null;
var lbCtr  = null;
var lbCls  = null;
var lbPrev = null;
var lbNext = null;
var lbc    = 0;
var allImgs = [];

function getSlides() {
  return document.querySelectorAll('#galSlider .gs-img-item');
}

function openLb(i) {
  if (!lb) return;
  lbc = i;
  upLb();
  lb.classList.add('open');
  lb.setAttribute('aria-hidden', 'false');
  PE.lockScroll();
  if (lbCls) lbCls.focus();
}

function closeLb() {
  if (!lb) return;
  lb.classList.remove('open');
  lb.setAttribute('aria-hidden', 'true');
  PE.unlockScroll();
}

function upLb() {
  var ss  = getSlides();
  var s   = ss[lbc];
  var img = s && s.querySelector('img');
  if (lbImg) {
    lbImg.src = img ? (img.dataset.zoom || img.src) : '';
    lbImg.alt = img ? (img.alt || '') : '';
  }
  if (lbCtr) lbCtr.textContent = (lbc + 1) + ' / ' + ss.length;
  /* Show/hide prev-next based on count */
  var n = ss.length;
  if (lbPrev) lbPrev.style.display = n > 1 ? 'flex' : 'none'; /* flex on all devices */
  if (lbNext) lbNext.style.display = n > 1 ? 'flex' : 'none';
}

function lbGo(d) {
  var n = getSlides().length;
  lbc = ((lbc + d) % n + n) % n;
  upLb();
}

/* ── Colour Swatch Gallery Swap ── */
window.swapSliderImages = function(images, zooms) {
  var slider = document.getElementById('galSlider');
  if (!slider) return;
  slider.innerHTML = '';

  /* Update grid layout classes based on image count */
  slider.classList.remove('gs-img-grid--single', 'gs-img-grid--three');
  if (images.length === 1) {
    slider.classList.add('gs-img-grid--single');
  } else if (images.length === 3) {
    slider.classList.add('gs-img-grid--three');
  }

  images.forEach(function(src, i) {
    var d = document.createElement('div');
    d.className = 'gs-img-item';
    d.dataset.index = i;
    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.loading = i === 0 ? 'eager' : 'lazy';
    img.dataset.zoom = zooms[i] || src;
    img.draggable = false;
    d.appendChild(img);
    slider.appendChild(d);
  });
  initClickHandlers();
};

/* ── Attach click to gallery items ── */
function initClickHandlers() {
  var slider = document.getElementById('galSlider');
  if (!slider) return;
  /* Remove old handlers by re-delegating on the container */
  slider.onclick = function(e) {
    var item = e.target.closest('.gs-img-item');
    if (!item) return;
    var idx = parseInt(item.dataset.index) || 0;
    /* Recalculate from DOM position too */
    var items = slider.querySelectorAll('.gs-img-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i] === item) { idx = i; break; }
    }
    openLb(idx);
  };
  /* Touch: tap → lightbox, swipe → next/prev image */
  var touchX = 0, touchY = 0, currentIdx = 0;

  function updateDots(idx) {
    var dots = document.querySelectorAll('#galDots .gal-dot');
    dots.forEach(function(d,i){ d.classList.toggle('on', i===idx); });
    currentIdx = idx;
  }

  function goToImage(idx) {
    var items = slider.querySelectorAll('.gs-img-item');
    if(idx < 0 || idx >= items.length) return;
    /* v42 auditoria B: scrollTo no proprio carrossel (o scrollIntoView nao mexia o #galSlider com scroll-snap) */
    slider.scrollTo({ left: items[idx].offsetLeft, behavior:'smooth' });
    updateDots(idx);
  }

  slider.addEventListener('touchstart', function(e) {
    touchX = e.touches[0].clientX;
    touchY = e.touches[0].clientY;
  }, { passive: true });

  slider.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - touchX;
    var dy = Math.abs(e.changedTouches[0].clientY - touchY);
    var absDx = Math.abs(dx);
    if(absDx > 40 && absDx > dy) {
      /* Swipe: go next or prev */
      var items = slider.querySelectorAll('.gs-img-item');
      var next = currentIdx + (dx < 0 ? 1 : -1);
      goToImage(Math.max(0, Math.min(next, items.length-1)));
    } else if(absDx < 10) {
      /* Tap: open lightbox */
      var item = e.target.closest('.gs-img-item');
      if(!item) return;
      var items = slider.querySelectorAll('.gs-img-item');
      for(var i=0;i<items.length;i++){ if(items[i]===item){ openLb(i); break; } }
    }
  }, { passive: true });

  /* Dot clicks */
  var dotsEl = document.getElementById('galDots');
  if(dotsEl) {
    dotsEl.addEventListener('click', function(e) {
      var dot = e.target.closest('.gal-dot');
      if(!dot) return;
      var idx = parseInt(dot.dataset.index) || 0;
      goToImage(idx);
    });
  }

  /* Update dot on scroll */
  slider.addEventListener('scroll', function() {
    var items = slider.querySelectorAll('.gs-img-item');
    var slLeft = slider.scrollLeft;
    var closest = 0, minDiff = Infinity;
    items.forEach(function(item, i) {
      var diff = Math.abs(item.offsetLeft - slLeft);
      if(diff < minDiff){ minDiff=diff; closest=i; }
    });
    if(closest !== currentIdx) updateDots(closest);
  }, { passive: true });
}

/* ── Product accordions ── */
function initAccordions() {
  PE.qsa('[data-gs-acc]').forEach(function(btn, idx) {
    if (btn._accInit) return;
    btn._accInit = true;
    btn.addEventListener('click', function() {
      var body = btn.nextElementSibling;
      var open = btn.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(open));
      if (body) {
        body.classList.toggle('open', open);
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      }
    });
    /* Open Description (first accordion) by default */
    if (idx === 0) {
      btn.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      var body = btn.nextElementSibling;
      if (body) {
        body.classList.add('open');
        requestAnimationFrame(function() {
          body.style.maxHeight = body.scrollHeight + 'px';
        });
      }
    }
  });
}

/* ── Sticky ATC ── */
function initStickyAtc() {
  var stickyAtc    = PE.qs('#stickyAtc');
  var stickyAtcBtn = PE.qs('#stickyAtcBtn');
  var mainAtcWrap  = PE.qs('.gs-atc-wrap');
  if (stickyAtc && mainAtcWrap) {
    var io = new IntersectionObserver(function(entries) {
      stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
    });
    io.observe(mainAtcWrap);
  }
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function() {
      var mainBtn = PE.qs('#prodAtcBtn');
      if (mainBtn) mainBtn.click();
    });
  }
}

/* ── Colour swatch swap ── */
function initColourSwatches() {
  PE.qsa('.gs-color-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      PE.qsa('.gs-color-thumb[data-opt="' + thumb.dataset.opt + '"]').forEach(function(t) {
        t.classList.remove('on');
      });
      thumb.classList.add('on');
      /* v36 3S: sem aria-checked (nao e permitido num botao). O estado e dado por aria-pressed,
         sincronizado com a classe "on" pelo script da ficha (product-page.liquid). */
      var imgs  = (thumb.dataset.images || '').split('|||').filter(Boolean);
      var zooms = (thumb.dataset.zoom   || '').split('|||').filter(Boolean);
      /* v42 auditoria B: a troca de fotos fica so' no pe-colour-swap.js */
      void imgs; void zooms;
    });
  });
}

/* ── Init ── */
document.addEventListener('DOMContentLoaded', function() {
  lb      = PE.qs('#galLightbox');
  lbImg   = PE.qs('#galLbImg');
  lbCtr   = PE.qs('#galLbCounter');
  lbCls   = PE.qs('#galLbClose');
  lbPrev  = PE.qs('#galLbPrev');
  lbNext  = PE.qs('#galLbNext');

  initClickHandlers();
  initAccordions();
  initStickyAtc();
  initColourSwatches();

  if (!lb) return;

  /* Lightbox controls */
  if (lbCls)  lbCls.addEventListener('click',  closeLb);
  if (lbPrev) lbPrev.addEventListener('click',  function() { lbGo(-1); });
  if (lbNext) lbNext.addEventListener('click',  function() { lbGo(1); });

  lb.addEventListener('click', function(e) {
    if (e.target === lb || e.target.id === 'galLbImgWrap') closeLb();
  });

  /* Touch swipe in lightbox */
  var lbsx = 0;
  lb.addEventListener('touchstart', function(e) { lbsx = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend',   function(e) {
    var dx = e.changedTouches[0].clientX - lbsx;
    if (Math.abs(dx) > 40) lbGo(dx < 0 ? 1 : -1);
  }, { passive: true });

  /* Keyboard */
  document.addEventListener('keydown', function(e) {
    if (!lb.classList.contains('open')) return;
    if (e.key === 'Escape')     closeLb();
    if (e.key === 'ArrowRight') lbGo(1);
    if (e.key === 'ArrowLeft')  lbGo(-1);
  });
});

})();

/* v36 Fase 3Q - GALERIA PELO TECLADO + PONTOS COM AREA DE TOQUE DE 24px
   - cada foto passa a ser um botao: Tab chega a ela, Enter ou Espaco abrem a ampliacao
     (faz o mesmo clique que o rato/toque ja faziam - os varios ouvintes do tema continuam a mandar);
   - setas esquerda/direita passam para a foto anterior/seguinte (no telemovel o carrossel acompanha);
   - contorno visivel so com teclado (:focus-visible), por dentro da foto para nao ser cortado;
   - ao fechar a ampliacao o foco volta a foto que a abriu;
   - o #galSlider deixa de ser paragem de Tab (as fotos ja sao) mas continua focavel por codigo;
   - pontos da galeria: o ponto continua com 6px (22px o ativo), mas o botao passa a ter 24x24px de area
     de toque (preenchimento transparente) e os pontos ficam a 24px de distancia uns dos outros.
   As fotos sao reconstruidas pelo pe-colour-swap.js quando se muda de cor: um MutationObserver volta a
   preparar as novas. Nada muda no aspeto da galeria no computador. */
(function () {
  'use strict';
  var TX = {
    pt: ['Fotografias do produto', 'Ampliar foto'],
    en: ['Product photos', 'Enlarge photo'],
    es: ['Fotos del producto', 'Ampliar foto'],
    fr: ['Photos du produit', 'Agrandir la photo'],
    de: ['Produktfotos', 'Foto vergrößern'],
    it: ['Foto del prodotto', 'Ingrandisci la foto']
  };
  function tx() { var l = (document.documentElement.getAttribute('lang') || 'pt').slice(0, 2).toLowerCase(); return TX[l] || TX.en; }
  var opener = null;

  function css() {
    if (document.getElementById('pe-3q-gal')) return;
    var s = document.createElement('style');
    s.id = 'pe-3q-gal';
    s.textContent = [
      'html body #galSlider .gs-img-item:focus{outline:none}',
      'html body #galSlider .gs-img-item:focus-visible{outline:2px solid #111 !important;outline-offset:-3px !important}',
      'html body #galSlider:focus-visible{outline:2px solid #111 !important;outline-offset:-3px !important}',
      'html body #galDots{gap:0 !important}',
      'html body #galDots .gal-dot{box-sizing:content-box !important;padding:9px !important;background-clip:content-box !important;border:0 !important;margin:0 !important;min-width:0 !important;min-height:0 !important}',
      'html body #galDots .gal-dot:focus{outline:none}',
      'html body #galDots .gal-dot:focus-visible{outline:2px solid #111 !important;outline-offset:-2px !important;border-radius:6px !important}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function items() {
    var g = document.getElementById('galSlider');
    return g ? Array.prototype.slice.call(g.querySelectorAll('.gs-img-item')) : [];
  }

  function prep() {
    var g = document.getElementById('galSlider');
    if (!g) return;
    var T = tx();
    g.setAttribute('role', 'region');
    g.setAttribute('aria-label', T[0]);
    g.setAttribute('tabindex', '-1');
    var list = items(), n = list.length;
    list.forEach(function (el, i) {
      var im = el.querySelector('img');
      if (!im) return;
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      var a = im.getAttribute('alt') || '';
      el.setAttribute('aria-label', (a ? a + ' – ' : '') + T[1] + ' (' + (i + 1) + '/' + n + ')');
    });
  }

  function dotFor(i) {
    var d = document.querySelectorAll('#galDots .gal-dot')[i];
    return d && d.offsetParent ? d : null;
  }

  document.addEventListener('keydown', function (e) {
    var it = e.target && e.target.closest ? e.target.closest('#galSlider .gs-img-item') : null;
    if (!it) return;
    var list = items(), i = list.indexOf(it);
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      opener = it;
      it.click();
      return;
    }
    var j = -1;
    if (e.key === 'ArrowRight') j = i + 1;
    if (e.key === 'ArrowLeft') j = i - 1;
    if (j < 0 || j >= list.length) return;
    e.preventDefault();
    var nx = list[j];
    try { nx.focus({ preventScroll: true }); } catch (err) { nx.focus(); }
    var d = dotFor(j);
    if (d) d.click();
    else { try { nx.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (err) {} }
  }, true);

  /* ao fechar a ampliacao, o foco volta a foto que a abriu */
  function watchLb() {
    var lb = document.getElementById('galLightbox');
    if (!lb || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (opener && !lb.classList.contains('open')) {
        var o = opener; opener = null;
        if (document.body.contains(o)) { try { o.focus({ preventScroll: true }); } catch (err) { o.focus(); } }
      }
    }).observe(lb, { attributes: true, attributeFilter: ['class'] });
  }

  function boot() {
    var g = document.getElementById('galSlider');
    if (!g) return;
    css();
    prep();
    watchLb();
    if ('MutationObserver' in window) new MutationObserver(prep).observe(g, { childList: true });
    window.addEventListener('load', prep);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
